import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/bom";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async categories(params: any) {
    return api.categories(params);
  }

  @Action
  async materialList(params: any) {
    return api.materialList(params);
  }

  @Action
  async addMaterial(params: any) {
    return api.addMaterial(params);
  }

  @Action
  async editMaterial(params: any) {
    return api.editMaterial(params);
  }

  @Action
  async detailMaterial(params: any) {
    return api.detailMaterial(params);
  }

  @Action
  async deleteMaterial(params: any) {
    return api.deleteMaterial(params);
  }

  @Action
  async materialCategoryList(params: any) {
    return api.materialCategoryList(params);
  }

  @Action
  async addMaterialCategory(params: any) {
    return api.addMaterialCategory(params);
  }

  @Action
  async editMaterialCategory(params: any) {
    return api.editMaterialCategory(params);
  }

  @Action
  async detailMaterialCategory(params: any) {
    return api.detailMaterialCategory(params);
  }

  @Action
  async deleteMaterialCategory(params: any) {
    return api.deleteMaterialCategory(params);
  }
}
